import { computed, inject, Injectable, Signal } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';

import { FeatureFlag } from '../models/feature-flag.enum';
import { SystemService } from './system.service';

@Injectable({ providedIn: 'root' })
export class FeatureFlagService {
  private systemService = inject(SystemService);

  private tenantSettings$ = toSignal(this.systemService.getTenantSettings());

  private enabledFeatures$ = computed(() => this.tenantSettings$()?.moduleSettings?.enabledFeatures ?? []);

  isEnabled$(flag: FeatureFlag): Signal<boolean> {
    return computed(() => this.enabledFeatures$().includes(flag));
  }
}
